class BxfFormConstants {
    static STRING = {
        CONTAINER: 'bxf-form__container',
        HEADER: 'oneds-blk-heading-xxs',
        SPACING: 'bxf-form__spacing',
        FORM_GROUP_TAGNAME: 'BXF-FORM-GROUP',
    };
}

export { BxfFormConstants as B };
